// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuex from 'vuex'
import router from './router'
import chart from 'chart.js'
import axios from 'axios'
import DateFilter from './filters/date'
import PrettyFilter from './filters/pretty'
import login from './components/User/login'
import signup from './components/User/signUp'
import btrticker from './components/btr-ticker'
import btrchart from './components/btr-chart'
import btrdonut from './components/btr-donut'
import btrsocial from './components/btr-social'
import btrhappy from './components/btr-happy'
import btrfirst from './components/splash/btr-first'
import btrsplash from './components/splash/btr-splash'
import btrabout from './components/splash/btr-about'
import btrterms from './components/splash/btr-terms'
import btrdonate from './components/splash/btr-donate'
import btraddcoin from './components/splash/btr-addcoin'
import btrdisclaim from './components/splash/btr-disclaim'
import btrprivacy from './components/splash/btr-privacy'
import btrhappyoffer from './components/splash/btr-happyoffer'

import vSelect from 'vue-select'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fab)
Vue.component('btr-login', login)
Vue.component('btr-signup', signup)
Vue.component('btr-happy', btrhappy)
Vue.component('btr-happyoffer', btrhappyoffer)
Vue.component('btr-ticker', btrticker)
Vue.component('btr-chart', btrchart)
Vue.component('btr-donut', btrdonut)
Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('btr-social', btrsocial)
Vue.component('btr-splash', btrsplash)
Vue.component('btr-addcoin', btraddcoin)
Vue.component('btr-donate', btrdonate)
Vue.component('btr-terms', btrterms)
Vue.component('btr-about', btrabout)
Vue.component('btr-first', btrfirst)
Vue.component('btr-disclaim', btrdisclaim)
Vue.component('btr-privacy', btrprivacy)

Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.filter('pretty', PrettyFilter)
Vue.filter('date', DateFilter)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  chart,
  axios,
  router,
  Vuex,
  template: '<App/>',
  components:
  { App },
  created () {
  }
})



// WEBPACK FOOTER //
// ./src/main.js